export const getDefaultParentChildId = (studentList = []) =>
  studentList[0]?.id || studentList[0]?.student_id || "";

export const getParentNotificationCount = (payload) => {
  if (payload == null) return 0;
  if (typeof payload === "number") return Number(payload) || 0;
  if (typeof payload === "object" && !Array.isArray(payload)) {
    if (payload.count != null && typeof payload.count !== "object") {
      return Number(payload.count) || 0;
    }
    return 0;
  }
  return Number(payload) || 0;
};

export const getParentNotificationCountForChild = (countPayload) =>
  getParentNotificationCount(countPayload);

export const getChildMsgCount = (student) => Number(student?.msg_count) || 0;
